/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_TabInputs */

const en_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins`)
};

const fr_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plug-ins`)
};

const de_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins`)
};

const it_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin`)
};

const ru_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плагины`)
};

const es_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementos`)
};

const zh_cn2_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插件`)
};

const ja_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラグイン`)
};

const hi_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लग-इन`)
};

const pt_pt2_team_manager_plugins_tab = /** @type {(inputs: Team_Manager_Plugins_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins`)
};

/**
* | output |
* | --- |
* | "Plugins" |
*
* @param {Team_Manager_Plugins_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_tab = /** @type {((inputs?: Team_Manager_Plugins_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_plugins_tab(inputs)
	if (locale === "de") return de_team_manager_plugins_tab(inputs)
	if (locale === "it") return it_team_manager_plugins_tab(inputs)
	if (locale === "ru") return ru_team_manager_plugins_tab(inputs)
	if (locale === "es") return es_team_manager_plugins_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_plugins_tab(inputs)
	if (locale === "ja") return ja_team_manager_plugins_tab(inputs)
	if (locale === "hi") return hi_team_manager_plugins_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_plugins_tab(inputs)
	return en_team_manager_plugins_tab(inputs)
});